import React,{useState,useContext} from "react";
import "../styles/Dashboard.css";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { Link } from "react-router-dom";
import ArticleIcon from "@mui/icons-material/Article";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import DescriptionIcon from "@mui/icons-material/Description";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import {Alert} from "@mui/material";
import GroupsIcon from '@mui/icons-material/Groups';
import { StudentDetailsContext } from "../store/student-details";

const Dashboard = () => {
  // const studentDetailsContext = useContext(StudentDetailsContext);
    const StudentContext = useContext(StudentDetailsContext);

    const[showModal,setShowModal] = useState(true);

    const[AdmissionNumber,setAdmissionNumber] = useState("");
    const[Amount,setAmount] = useState("");
    const[currentDate,setCurrentDate] = useState("");


    function handleShowModal(){
        setShowModal(!showModal);
    }
    function handlePaymentDetails(e){
        // alert("")
        e.preventDefault();
        console.log("Admission Number ",AdmissionNumber);
        console.log("Amount Paid ",Amount);
        console.log("Current Date ",currentDate);

        StudentContext.updateFeeDetails(AdmissionNumber,Amount,currentDate);

    }
  return (
    <div className="dashboardMainDiv">
      <div className="dashboardMenu">
        <ul className="dashboardDropdownList">
          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/">
                Dashboard
              </Link>
            </li>
            <li className="listItemIcon">
              <DashboardIcon />
            </li>
          </div>

          {/* <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/students">
                Students
              </Link>
            </li>
            <li className="listItemIcon">
              <SchoolIcon />
            </li>
          </div> */}

          {/* <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/analytics">
                Analytics
              </Link>
            </li>
            <li className="listItemIcon">
              <BarChartIcon />
            </li>
          </div> */}

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/bonafide">
                Bonafide
              </Link>
            </li>
            <li className="listItemIcon">
              <ArticleIcon />
            </li>
          </div>

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/receipt">
                Receipt
              </Link>
            </li>
            <li className="listItemIcon">
              <ReceiptLongIcon />
            </li>
          </div>

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/exams">
                Exams
              </Link>
            </li>
            <li className="listItemIcon">
              <DescriptionIcon />
            </li>
          </div>

          <div className="listItemContainer activeContainer">
            <li className="listItem">
              <Link className="linkItem" to="/feeDetails">
                Fee Details
              </Link>
            </li>
            <li className="listItemIcon">
              <CurrencyRupeeIcon />
            </li>
          </div>

          <div className="listItemContainer">
            <li className="listItem">
              <Link className="linkItem" to="/uploadAttendance">
                Attendance
              </Link>
            </li>
            <li className="listItemIcon">
              <GroupsIcon />
            </li>
          </div>
        </ul>
      </div>
      <div className="dashboardContent">
        <div className="container dashboardContentContainer">
          <div className="row">
          <div className="container">
                        <div className="row">
                            <div className="col-lg-10 mt-5">
                            {
                                StudentContext && StudentContext.isUpdated && showModal? <>
                                    <Alert onClose = {handleShowModal}>
                                        Fee Details Updated!!
                                    </Alert>
                                </> : <></>
                            }
                                <div className="card">
                                <p className="text text-center text-success mt-3  py-1 col-lg-8 ml-5">Updating Fee Details of a Student</p>
                                <div style={{position:"absolute",top:0,right:'10px'}}>
                                    
                                </div>
                                    <div className="col-lg-10 mt-5 px-5">

                                        <form
                                         >
                                            <div className="col-lg-12 my-3">
                                            <label style={{fontSize:'14px',color:"green"}}>Admission Number</label>
                                            <input type="number" className="form-control" placeholder="Enter Student Admission Number"
                                                onChange={(e)=>setAdmissionNumber(e.target.value)}
                                            />
                                            </div>

                                            <div className="col-lg-12 my-3">
                                            <label style={{fontSize:'14px',color:"green"}}>Amount Paid</label>
                                            <input type="number" className="form-control" placeholder="Enter Amount"
                                                onChange={(e)=>setAmount(e.target.value)}

                                            />
                                            </div>

                                            <div className="col-lg-12 my-3">
                                            <label style={{fontSize:'14px',color:"green"}}>Choose Date</label>

                                            <input type="date" className="form-control" placeholder="Choose Date"
                                                onChange={(e)=>setCurrentDate(e.target.value)}

                                            />
                                            </div>

                                            <div className="col-lg-6 d-flex flex-row  py-3"
                                            >
                                                <button className="btn btn-sm btn-primary px-5" type="submit"
                                                
                                                onClick={ (e)=>handlePaymentDetails(e) }>
                                                {StudentContext && StudentContext.loading ?  "Loading" : "Proceed"}
                                                </button>
                                            </div>
                                        </form>
                                   
                                    </div>
                                    
                                </div>
                                <div className="my-4">
                                        <button className="btn btn-sm px-5 btn-dark">
                                            <a href="/ViewFeeDetails" style={{color:"white"}}>View Collected Fee Details</a>
                                        </button>
                                    </div>
                            </div>
                        </div>
                    </div>
           
          </div>

          
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
